import axios from 'axios';
import { all, put, select, takeLatest } from 'redux-saga/effects';

import { COMPANIES } from 'app/api-routes';
import {
  settingsRequest,
  settingsSuccess,
  settingsFailure,
  updateSettingsRequest,
  updateSettingsSuccess,
  updateSettingsFailure,
} from './actions';

const selectCompanyID = (state) => state.auth?.companyInfo?.companyID;

function* settingsSaga() {
  try {
    const companyID = yield select(selectCompanyID);
    if (companyID == null) {
      yield put(settingsFailure(new Error('companyID missing')));
      return;
    }
    const { payload } = yield axios.get(
      `${COMPANIES}/${companyID}/teams-settings`
    );
    yield put(settingsSuccess(payload));
  } catch (err) {
    yield put(settingsFailure(err));
  }
}

function* updateSettingsSaga({ payload }) {
  try {
    const companyID = yield select(selectCompanyID);
    if (companyID == null) {
      yield put(updateSettingsFailure(new Error('companyID missing')));
      return;
    }
    // createSuccess carries no meta creator — a second argument would be silently dropped
    // (review 2026-08-05: the chatSettings original passes dead `{ warnings }` args).
    yield axios.put(`${COMPANIES}/${companyID}/teams-settings`, { payload });
    yield put(updateSettingsSuccess(payload));
    // Re-GET so the "Updated {when} by {name}" audit footer reflects the change just made.
    yield put(settingsRequest());
  } catch (err) {
    yield put(updateSettingsFailure(err));
  }
}

export default function* () {
  yield all([
    takeLatest(settingsRequest, settingsSaga),
    takeLatest(updateSettingsRequest, updateSettingsSaga),
  ]);
}
